module.exports = __webpack_public_path__ + "static/media/eye_block.5a323ed2.svg";